<template lang="pug">
  div
    el-button(
      class="btn"
      :disabled="disabled"
      type="primary"
      @click="toggleBtn"
      plain
    )
      i(:class="btnIcon" style="margin-top: -1vh;")
    span(class="label")
      slot
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },

      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      btnIcon() {
        return this.value ? 'fa fa-minus' : 'fa fa-plus'
      },
    },

    methods: {
      toggleBtn() {
        this.$emit('input', !this.value)
      },
    },
  }
</script>

<style scoped>
  .btn {
    padding: 0px;
    height: 2.35em;
    font-size: 0.85em;
    & i {
      font-style: normal !important;
    }
  }

  .label {
    color: #757575;
    margin-left: 10px;
    font-size: 1em;
  }
</style>
